export * from './baSlider.component';
